/* eslint-disable @typescript-eslint/no-explicit-any */
export const isOnlyNumbers = (text?: any) => {
  const paramType = typeof text;

  if (paramType === 'number') {
    return true;
  }

  if (paramType === 'string') {
    return /^[0-9]*$/.test(text);
  }

  return false;
};

export const isBase64Image = (text?: string) => {
  if (!text) {
    return false;
  }

  const base64ImageRegex =
    /^data:image\/(?:gif|png|jpeg|bmp|webp|svg\+xml)(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}/;

  return base64ImageRegex.test(text);
};

export const isBase64 = (text?: string) => {
  if (!text) {
    return false;
  }

  const regexBase64 =
    /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/;

  return regexBase64.test(text);
};

export const isUrl = (url?: string) => {
  if (!url) return false;

  if (url.trim().length < 1) return false;

  const regexUrl = /(.*):(\d*)\/?(.*)/;

  return regexUrl.test(url);
};
